import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import { FaExternalLinkAlt, FaLock } from 'react-icons/fa';
import './Portfolio.css';

const Portfolio = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: t('portfolio.time4barberLanding.title'),
      category: 'web',
      image: '/images/time4barber-landing.png',
      description: t('portfolio.time4barberLanding.description'),
      technologies: ['React', 'SEO'],
      noLinks: true
    },
    {
      id: 2,
      title: t('portfolio.time4barberAdmin.title'),
      category: 'mobile',
      image: '/images/time4barber-admin.png',
      description: t('portfolio.time4barberAdmin.description'),
      technologies: ['React Native', 'Expo', 'TypeScript'],
      noLinks: true
    },
    {
      id: 3,
      title: t('portfolio.time4barberClient.title'),
      category: 'mobile',
      image: '/images/time4barber-client.png',
      description: t('portfolio.time4barberClient.description'),
      technologies: ['React Native', 'Expo', 'TypeScript'],
      noLinks: true
    },
    {
      id: 4,
      title: t('portfolio.vyro.title'),
      category: 'web',
      image: '/images/vyro-logo.png',
      description: t('portfolio.vyro.description'),
      technologies: ['Angular 18', 'FastAPI', 'PostgreSQL', 'Supabase'],
      noLinks: true
      //liveUrl: 'https://vyro.boutique'
    },
    {
      id: 5,
      title: t('portfolio.vyroCms.title'),
      category: 'web',
      image: '/images/vyro-logo.png',
      description: t('portfolio.vyroCms.description'),
      technologies: ['Angular 18', '.NET 10', 'PostgreSQL'],
      noLinks: true
    }
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <section id="portfolio" className="section portfolio">
      <div className="container">
        <h2 className="section-title">{t('portfolio.title')}</h2>
        
        <div className="portfolio-filters" role="tablist" aria-label="Filter projects">
          <button role="tab" aria-selected={filter === 'all'} className={filter === 'all' ? 'active' : ''} onClick={() => setFilter('all')}>{t('portfolio.all')}</button>
          <button role="tab" aria-selected={filter === 'web'} className={filter === 'web' ? 'active' : ''} onClick={() => setFilter('web')}>{t('portfolio.web')}</button>
          <button role="tab" aria-selected={filter === 'mobile'} className={filter === 'mobile' ? 'active' : ''} onClick={() => setFilter('mobile')}>{t('portfolio.mobile')}</button>
        </div>

        <div ref={ref} className="portfolio-grid">
          {filteredProjects.map((project, index) => (
            <article key={project.id} className={`portfolio-item ${inView ? 'fade-in' : ''}`} style={{ animationDelay: `${index * 0.15}s` }}>
              <div className="portfolio-image">
                <img src={project.image} alt={project.title} loading="lazy" />
                <div className="portfolio-overlay">
                  <div className="portfolio-actions">
                    {project.noLinks ? (
                      <div className="private-project">
                        <FaLock aria-hidden="true" />
                        <span>Private</span>
                      </div>
                    ) : (
                      <a href={project.liveUrl} target="_blank" rel="noopener noreferrer" className="active-link" title="View Project" aria-label={`View ${project.title}`}>
                        <FaExternalLinkAlt aria-hidden="true" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="portfolio-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="portfolio-technologies">
                  {project.technologies.map((tech, i) => (
                    <span key={i}>{tech}</span>
                  ))}
                </div>
                {project.noLinks && (
                  <div className="portfolio-private-badge">
                    <FaLock size={12} aria-hidden="true" />
                    <span>Private Architecture</span>
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;